'use strict';

var Relude_Tuple2 = require("./Relude_Tuple2.bs.js");
var Relude_Tuple3 = require("./Relude_Tuple3.bs.js");
var Relude_Tuple4 = require("./Relude_Tuple4.bs.js");
var Relude_Tuple5 = require("./Relude_Tuple5.bs.js");
var Relude_Function = require("./Relude_Function.bs.js");

var Tuple2;

var Tuple3;

var Tuple4;

var Tuple5;

var make = Relude_Tuple2.make;

var make2 = Relude_Tuple2.make;

var make3 = Relude_Tuple3.make;

var make4 = Relude_Tuple4.make;

var make5 = Relude_Tuple5.make;

var fromArray = Relude_Tuple2.fromArray;

var fromArray2 = Relude_Tuple2.fromArray;

var fromArray3 = Relude_Tuple3.fromArray;

var fromArray4 = Relude_Tuple4.fromArray;

var fromArray5 = Relude_Tuple5.fromArray;

var fromArrayAtLeast = Relude_Tuple2.fromArrayAtLeast;

var fromArrayAtLeast2 = Relude_Tuple2.fromArrayAtLeast;

var fromArrayAtLeast3 = Relude_Tuple3.fromArrayAtLeast;

var fromArrayAtLeast4 = Relude_Tuple4.fromArrayAtLeast;

var fromArrayAtLeast5 = Relude_Tuple5.fromArrayAtLeast;

var fromList = Relude_Tuple2.fromList;

var fromList2 = Relude_Tuple2.fromList;

var fromList3 = Relude_Tuple3.fromList;

var fromList4 = Relude_Tuple4.fromList;

var fromList5 = Relude_Tuple5.fromList;

var fromListAtLeast = Relude_Tuple2.fromListAtLeast;

var fromListAtLeast2 = Relude_Tuple2.fromListAtLeast;

var fromListAtLeast3 = Relude_Tuple3.fromListAtLeast;

var fromListAtLeast4 = Relude_Tuple4.fromListAtLeast;

var fromListAtLeast5 = Relude_Tuple5.fromListAtLeast;

var apply = Relude_Function.uncurry2;

var apply2 = Relude_Function.uncurry2;

var apply3 = Relude_Function.uncurry3;

var apply4 = Relude_Function.uncurry4;

var apply5 = Relude_Function.uncurry5;

var showBy = Relude_Tuple2.showBy;

var showBy2 = Relude_Tuple2.showBy;

var showBy3 = Relude_Tuple3.showBy;

var showBy4 = Relude_Tuple4.showBy;

var showBy5 = Relude_Tuple5.showBy;

var eqBy = Relude_Tuple2.eqBy;

var eqBy2 = Relude_Tuple2.eqBy;

var eqBy3 = Relude_Tuple3.eqBy;

var eqBy4 = Relude_Tuple4.eqBy;

var eqBy5 = Relude_Tuple5.eqBy;

var WithEqs2;

var WithEqs3;

var WithEqs4;

var WithEqs5;

var EqBy2;

var EqBy3;

var EqBy4;

var EqBy5;

var compareBy = Relude_Tuple2.compareBy;

var compareBy2 = Relude_Tuple2.compareBy;

var compareBy3 = Relude_Tuple3.compareBy;

var compareBy4 = Relude_Tuple4.compareBy;

var compareBy5 = Relude_Tuple5.compareBy;

var WithOrds2;

var WithOrds3;

var WithOrds4;

var WithOrds5;

var OrdBy2;

var OrdBy3;

var OrdBy4;

var OrdBy5;

exports.Tuple2 = Tuple2;
exports.Tuple3 = Tuple3;
exports.Tuple4 = Tuple4;
exports.Tuple5 = Tuple5;
exports.make = make;
exports.make2 = make2;
exports.make3 = make3;
exports.make4 = make4;
exports.make5 = make5;
exports.fromArray = fromArray;
exports.fromArray2 = fromArray2;
exports.fromArray3 = fromArray3;
exports.fromArray4 = fromArray4;
exports.fromArray5 = fromArray5;
exports.fromArrayAtLeast = fromArrayAtLeast;
exports.fromArrayAtLeast2 = fromArrayAtLeast2;
exports.fromArrayAtLeast3 = fromArrayAtLeast3;
exports.fromArrayAtLeast4 = fromArrayAtLeast4;
exports.fromArrayAtLeast5 = fromArrayAtLeast5;
exports.fromList = fromList;
exports.fromList2 = fromList2;
exports.fromList3 = fromList3;
exports.fromList4 = fromList4;
exports.fromList5 = fromList5;
exports.fromListAtLeast = fromListAtLeast;
exports.fromListAtLeast2 = fromListAtLeast2;
exports.fromListAtLeast3 = fromListAtLeast3;
exports.fromListAtLeast4 = fromListAtLeast4;
exports.fromListAtLeast5 = fromListAtLeast5;
exports.apply = apply;
exports.apply2 = apply2;
exports.apply3 = apply3;
exports.apply4 = apply4;
exports.apply5 = apply5;
exports.showBy = showBy;
exports.showBy2 = showBy2;
exports.showBy3 = showBy3;
exports.showBy4 = showBy4;
exports.showBy5 = showBy5;
exports.eqBy = eqBy;
exports.eqBy2 = eqBy2;
exports.eqBy3 = eqBy3;
exports.eqBy4 = eqBy4;
exports.eqBy5 = eqBy5;
exports.WithEqs2 = WithEqs2;
exports.WithEqs3 = WithEqs3;
exports.WithEqs4 = WithEqs4;
exports.WithEqs5 = WithEqs5;
exports.EqBy2 = EqBy2;
exports.EqBy3 = EqBy3;
exports.EqBy4 = EqBy4;
exports.EqBy5 = EqBy5;
exports.compareBy = compareBy;
exports.compareBy2 = compareBy2;
exports.compareBy3 = compareBy3;
exports.compareBy4 = compareBy4;
exports.compareBy5 = compareBy5;
exports.WithOrds2 = WithOrds2;
exports.WithOrds3 = WithOrds3;
exports.WithOrds4 = WithOrds4;
exports.WithOrds5 = WithOrds5;
exports.OrdBy2 = OrdBy2;
exports.OrdBy3 = OrdBy3;
exports.OrdBy4 = OrdBy4;
exports.OrdBy5 = OrdBy5;
/* Relude_Tuple2 Not a pure module */
